
interface TextAreaFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  required?: boolean;
  rows?: number;
  maxLength?: number;
}

const TextAreaField = ({ 
  label, 
  value, 
  onChange, 
  placeholder, 
  error,
  required = false,
  rows = 4,
  maxLength
}: TextAreaFieldProps) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="block text-white/90 font-medium text-sm">
          {label}
          {required && <span className="text-[#FFD700] ml-1">*</span>}
        </label>
        {maxLength && (
          <span className="text-white/90 text-xs">
            {value.length}/{maxLength}
          </span>
        )}
      </div>
      
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        className={`
          w-full px-4 py-3 rounded-xl bg-white/5 border-2 text-white placeholder-white/50
          transition-all duration-200 text-base resize-none
          ${error 
            ? 'border-red-500/50 focus:border-red-500' 
            : 'border-white/10 focus:border-[#FFD700]/50'
          }
          focus:outline-none focus:bg-white/10
        `}
      />
      
      {error && (
        <p className="text-red-400 text-xs flex items-center gap-1">
          <i className="ri-error-warning-line"></i>
          <span>{error}</span>
        </p>
      )}
    </div>
  );
};

export default TextAreaField;
